import { Box, Chip, Typography } from '@mui/material'
import { TagFilterProps } from '../CardView.types'

const TagFilter = ({ tags, selectedTags, onTagSelect }: TagFilterProps) => {
  const filteredTags = tags.filter((tag) => tag !== '')

  if (filteredTags.length === 0) {
    return null
  }

  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Filter by tags:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {filteredTags.map((tag, index) => {
          const isSelected = selectedTags.includes(tag)
          return (
            <Chip
              key={index}
              label={tag}
              color="primary"
              variant={isSelected ? 'filled' : 'outlined'}
              onClick={() => onTagSelect(tag)}
              clickable
              sx={{
                color: isSelected ? 'white' : undefined,
              }}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default TagFilter
